import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal} from '@angular/core';
import {NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet} from '@angular/router';
import {PostfachService} from './core/services/apiservices/postfach.service';
import {environment} from "../environments/environment";
import {KokosI18NextPipe} from "./shared/pipes/kokos-i18next/kokos-i18next.pipe";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, KokosI18NextPipe],
    providers: [PostfachService],
    templateUrl: './app.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent implements OnInit {
    readonly title = 'kokos-ui';

    readonly enableOAuth = environment.oiam.enabled;

    readonly isLoading = signal(true);

    protected router = inject(Router);

    ngOnInit(): void {
        this.handleLoading();
    }

    handleLoading(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.isLoading.set(true);
            } else if (event instanceof NavigationEnd || event instanceof NavigationError) {
                this.isLoading.set(false);
            }
        });
    }

}
